/**
 * Returns internationalized text associated with "key". Performs MessageFormat like
 * string replacement of {d}-expressions using additional parameters
 * If there is no text available, value of "def" is used.
 */
var i18n = function(key, def) {
  var pattern = undefined,
    hasNoTranslation,
    hasNoDefault,
    devMode = cfnGlobals.devMode;

  if (devMode === 'i18n-replace-all') {
    return '????';
  } else if (devMode === 'i18n-show-keys') {
    return '{' + key + '}';
  }

  if (app.translations) {
    pattern = app.translations[key];
  }

  hasNoTranslation = !pattern;
  hasNoDefault = !def;

  if (devMode === 'i18n-statistics') {
    //general init
    if (!i18n.statistics) {
      i18n.statistics = {
        keys: {}
      };
    }
    var state = i18n.statistics.keys[key];
    //key init
    if (!state) {
      state = i18n.statistics.keys[key] = {
        key: key,
        calls: 0,
        missing: hasNoTranslation,
        defs: {}
      };
    }

    state.calls++;
    state.defs[def] = (state.defs[def] || 0) + 1;
  }

  if (hasNoTranslation) {
    if (devMode === 'i18n-translation') {
      return '?' + key + '?';
    } else {
      pattern = def;
    }
  }

  if (typeof pattern === 'string') {
    // replace `&shy;` by actual soft hyphen, see https://en.wikipedia.org/wiki/Soft_hyphen
    // TODO: replace it SERVER-SIDE!
    pattern = pattern.replace(/([a-z]?)&shy;([a-z]?)/g, '$1\u00AD$2');

    if (arguments.length > 2) {
      var args = Array.prototype.slice.call(arguments, 2);
      return String.prototype.format.apply(pattern, args);
    }
    return pattern;
  }
  return key;
};

i18n.$stateful = true;

global.i18n = i18n;
